import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import WwwLayout from "@/app/(www)/_layout";
import Home from "@/app/(www)/home";
import Features from "@/app/(www)/features";
import Pricing from "@/app/(www)/pricing";
import Help from "@/app/(www)/help";
import Contact from "@/app/(www)/contact";
import Privacy from "@/app/(www)/privacy";
import Terms from "@/app/(www)/terms";
import Download from "@/app/(www)/download";
import Shop from "@/app/(www)/shop";
import Welcome from "@/app/(auth)/welcome";
// Temporary placeholder for pages that have not been migrated yet
// (features, pricing, help, contact, privacy, terms). The Layout still
// renders the navbar/footer around it so the visual frame stays intact.
function ComingSoonPage() {
  return (
    <div style={{ padding: 64, textAlign: "center", color: "#FAFAFA", fontSize: 18, minHeight: 240 }}>
      Página en construcción
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth screens live outside the marketing layout (no navbar/footer) */}
        <Route path="/(auth)/welcome" element={<Welcome />} />

        {/* Google Play "Data safety" account-deletion URL. Redirects to the
            Help FAQ (Q7) so we keep a single source of truth for the copy. */}
        <Route path="/delete-account" element={<Navigate to="/help#delete-account" replace />} />

        {/* Apple App Review Guideline 3.1.2(c): legal URL aliases used in App
            Store metadata must resolve. Permanent client-side redirects to the
            canonical legal pages (single source of truth, no duplicated copy). */}
        <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
        <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />

        {/* Friendly alias: /support is a plausible URL — send it to the Help Center. */}
        <Route path="/support" element={<Navigate to="/help" replace />} />

        <Route element={<WwwLayout />}>
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/help" element={<Help />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/descargar" element={<Download />} />
          <Route path="/download" element={<Download />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="*" element={<ComingSoonPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
